module.exports = __webpack_public_path__ + "static/img/2bg_21.c093ef7.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/2bg_21.png
// module id = 669
// module chunks = 1